import { desaturate, lighten } from "polished";
import styled from "@emotion/styled";
var Wrapper = /*#__PURE__*/ styled("div", {
    target: "eozo8fq0"
})("position:absolute;left:0;top:3.5rem;z-index:50;margin:0;padding:0;width:100%;max-height:400px;overflow-y:auto;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";border:0.125rem solid\n    ", function(param) {
    var theme = param.theme;
    return lighten(0.065, desaturate(0.25, theme.color.primaryHighlight));
}, ";border-radius:0.5rem;box-shadow:0 4px 6px -1px rgb(0 0 0 / 10%),0 2px 4px -2px rgb(0 0 0 / 10%);font-size:1rem;line-height:1.5;list-style-type:none;");
var Headline = /*#__PURE__*/ styled("div", {
    target: "eozo8fq1"
})("padding:0.75rem 0.75rem 0.25rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural30;
}, ";font-size:0.875rem;font-weight:bold;letter-spacing:0.2em;text-transform:uppercase;");
var List = /*#__PURE__*/ styled("ul", {
    target: "eozo8fq2"
})("margin:0;padding:0;list-style:none;li{border-bottom:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";}");
var ItemButton = /*#__PURE__*/ styled("button", {
    target: "eozo8fq3"
})("margin:0;padding:0.75rem;border:0;width:100%;font:inherit;text-align:left;color:inherit;background:none;cursor:pointer;&:hover{background-color:", function(param) {
    var theme = param.theme;
    return lighten(0.065, desaturate(0.25, theme.color.primaryHighlight));
}, ";}");
var Destination = /*#__PURE__*/ styled("span", {
    target: "eozo8fq4"
})("display:block;font-weight:600;");
var Duration = /*#__PURE__*/ styled("time", {
    target: "eozo8fq5"
})("display:block;font-size:0.875rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural30;
}, ";");
var DeleteButton = /*#__PURE__*/ styled("button", {
    target: "eozo8fq6"
})("margin:0;padding:0.75rem;border:0;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1rem;font-weight:bold;text-align:left;color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";background:none;cursor:pointer;&:hover{text-decoration:none;}");
export { Wrapper, Headline, List, ItemButton, Destination, Duration, DeleteButton };
